import type { TableAction, TableActionGroup } from '@shared/types/data-table'

export const ACTION_SECTION_LABELS = {
  VIEW: 'VIEW',
  ACTIONS: 'ACTIONS',
  LINKS: 'LINKS',
} as const

export interface GroupedActionSections<T> {
  /** VIEW section: view details, view profile, preview */
  view?: TableAction<T>[]
  /** ACTIONS section: edit, send, status changes, copy ID, duplicate, delete */
  actions?: TableAction<T>[]
  /** LINKS section: view customer, view merchant, navigation to related entities */
  links?: TableAction<T>[]
}

/**
 * Builds standardized grouped row actions with fixed order: VIEW → ACTIONS → LINKS.
 * Empty or omitted sections are automatically excluded.
 */
export function buildGroupedRowActions<T>(
  sections: GroupedActionSections<T>
): TableActionGroup<T>[] {
  const entries: Array<{ label: string; actions: TableAction<T>[] | undefined }> = [
    { label: ACTION_SECTION_LABELS.VIEW, actions: sections.view },
    { label: ACTION_SECTION_LABELS.ACTIONS, actions: sections.actions },
    { label: ACTION_SECTION_LABELS.LINKS, actions: sections.links },
  ]

  return entries
    .filter((entry): entry is { label: string; actions: TableAction<T>[] } =>
      !!entry.actions && entry.actions.length > 0
    )
    .map(entry => ({ label: entry.label, actions: entry.actions }))
}
